{
  "CxiLicenceType_SOLO": "Solo",
  "CxiLicenceType_TEAMS": "Teams",
  "CxiLicenceType_UNITE": "Vereinigen",
  "CxiLicenceType_NONE": "Keiner",
  "NAME": "CxiLicenceTypes"
}